<script setup>
const emit = defineEmits([
  'paymentSelected',
  'editClicked',
  'cardUpdated',
  'cardEditClosed',
])

const props = defineProps({
  paymentMethod: {
    type: Object,
    required: true,
  },
  shippingAddress: {
    type: Object,
    required: false,
    default: null,
  },
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  checked: {
    type: Boolean,
    default: false,
    required: false,
  },
  showMakeDefaultCheckbox: {
    type: Boolean,
    default: true,
    required: false,
  },
  forceDefault: {
    type: Boolean,
    default: false,
    required: false,
  },
  editable: {
    type: Boolean,
    default: true,
    required: false,
  },
  card: {
    type: Object,
    required: true,
  },
  hostedFieldsStyles: {
    type: Object,
    required: false,
    default() {
      return null
    },
  },
  addressLineOneId: {
    type: String,
    default: 'billing1',
  },
  customTheme: {
    type: Object,
    required: false,
    default: () => {
      return {
        makeDefaultCheckbox: {
          classes: 'small-12 checkmark-form-input',
          labelClasses: 'summary-edit-payment',
        },
      }
    },
  },
  floating: {
    type: Boolean,
    required: false,
    default: false,
  },
  idPrefix: {
    type: String,
    default: '',
  },
})
const editing = ref(false)
const checkoutCCForm = ref(null)
const formName = `${props.id}-checkout-payment-form`
const submitErrors = ref({})
const editMode = computed(() => editing.value && props.checked)

watch(
  () => props.checked,
  (newValue, oldValue) => {
    if (!newValue) {
      editing.value = false
    }
  },
)

function editClicked() {
  editing.value = true
  emit('editClicked', props.card)
}
function cancelClicked() {
  editing.value = false
  emit('cardEditClosed', props.id)
}
async function submitForm() {
  try {
    if (await checkoutCCForm.value.submitCCForm()) {
      emit('cardUpdated', props.id)
      editing.value = false
    }
  } catch (e) {
    Sentry.captureException(e)
    submitErrors.value = e.response.data
  }
}
</script>

<template>
  <li :id="'cc-summary-' + id" style="width: 100%">
    <div v-if="!editMode" class="cc-summary-item">
      <input
        :id="id"
        type="radio"
        :name="name"
        :value="id"
        :checked="checked"
        @click="emit('paymentSelected', card)"
      />
      <label :for="id">
        <strong
          >{{ paymentMethod.summary_string }}<br />
          <span class="cc-expiration">
            expires {{ paymentMethod.expiration_date }}
          </span></strong
        >
        <button v-if="editable" class="edit" @click="editClicked">Edit</button>
      </label>
    </div>
    <div
      v-if="editMode && editable"
      class="edit-existing"
      style="margin-bottom: 1.25rem"
    >
      <CheckoutCreditCardFK
        ref="checkoutCCForm"
        :custom-theme="customTheme"
        :initial="card"
        :name="formName"
        :include-number="false"
        :show-save-payment-details-checkbox="false"
        :show-make-default-checkbox="showMakeDefaultCheckbox"
        :force-default="forceDefault"
        :errors="submitErrors"
        :is-new-credit-card="false"
        :hosted-fields-styles="hostedFieldsStyles"
        :address-line-one-id="addressLineOneId"
        :floating="floating"
        :id-prefix="idPrefix"
      >
        <!-- eslint-disable-next-line vue/no-template-shadow -->
        <template #after-form>
          <div class="standard-form form-container">
            <CheckoutSectionSave
              :save-disabled="false"
              save-button-text="Save"
              template-class="row button-group save-cancel"
              submit-button-class="save-cancel-button"
              cancel-button-class="cancel save-cancel-button"
              @saveClicked="submitForm"
              @cancelClicked="cancelClicked"
            />
          </div>
        </template>
      </CheckoutCreditCardFK>
    </div>
  </li>
</template>

<style scoped></style>
